import styled from "styled-components";

export const ControlPanelContainer = styled.div``;